export enum AutosaveAction {
    TIMER = 'timer',
    FOCUS_OUT = 'focus_out',
    ON_DESTROY = 'on_destroy'
}
